module.exports = __webpack_public_path__ + "img/logo.dbf4b379.png";